module.exports = __webpack_public_path__ + "img/gc_country_flag_ar.9abcd37e.svg";